import { styled } from '~/styled'

export const TableFooter = styled('tfoot', {
  base: []
})

TableFooter.displayName = 'TableFooter'
